import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-offline',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './offline.html',
  styleUrl: './offline.scss',
})
export class Offline {
  ts = inject(TranslationService);
  t = this.ts.t;

  features = computed(() => [
    { num: '01', title: this.t().offline_feat1_title, desc: this.t().offline_feat1_desc },
    { num: '02', title: this.t().offline_feat2_title, desc: this.t().offline_feat2_desc },
    { num: '03', title: this.t().offline_feat3_title, desc: this.t().offline_feat3_desc },
    { num: '04', title: this.t().offline_feat4_title, desc: this.t().offline_feat4_desc },
    { num: '05', title: this.t().offline_feat5_title, desc: this.t().offline_feat5_desc },
  ]);
}